import sentinelImage from '../assets/images/projects/sentinelss.png';
import youtritionImage from '../assets/images/projects/bigyt.png';
import portfolioImage from '../assets/images/projects/pfting.png';
import sterlingImage from '../assets/images/projects/sterling.png';
import weatherImage from '../assets/images/projects/weather.png';
import plekImage from '../assets/images/projects/plek.png';
import regimeImage from '../assets/images/projects/regime.png';

export const projects = [
  {
    title: 'Regime — AI Market Intelligence Terminal',
    description:
      'A full-stack trading and market intelligence platform built with Next.js and FastAPI, combining regime detection, AI briefings, macro monitoring, and watchlist intelligence. It includes secure auth, delivery workflows, and production deployment on DigitalOcean App Platform with Managed PostgreSQL and Gradient AI.',
    url: 'https://devpost.com/software/regime',
    year: 2026,
    image: regimeImage,
    tech: ['Next.js', 'FastAPI', 'TypeScript', 'PostgreSQL', 'Pandas', 'scikit-learn', 'DigitalOcean'],
  },
  {
    title: 'Sentinel — Clinical Symptom Summary Platform',
    description:
      'A full-stack clinician workflow built with Next.js and FastAPI, featuring dual LLM support (Gemini and Meta Llama) for structured symptom extraction. It includes PII sanitization, RAG-style history with MongoDB, and automated deployment via GitHub Actions to Cloud Run.',
    url: 'https://oribyte-sentinel.vercel.app/',
    year: 2025,
    image: sentinelImage,
    tech: ['Next.js', 'FastAPI', 'Google Gemini', 'Meta Llama', 'MongoDB', 'Docker', 'Cloud Run'],
  },
  {
    title: 'Plek — Intelligent Academic Planning Agent',
    description:
      'An autonomous agentic workflow using FastAPI and Gemini that performs multi-step reasoning to validate prerequisites and automate degree scheduling. Features a high-performance RAG pipeline with pgvector for sub-100ms semantic search across 5,000+ courses.',
    url: '',
    year: 2025,
    image: plekImage,
    tech: ['FastAPI', 'Gemini 3 Flash', 'pgvector', 'SQLModel', 'PostgreSQL'],
  },
  {
    title: 'Personal Portfolio',
    description:
      'A responsive portfolio website showcasing projects, information about me, and a contact form. This was a project I had put on hold for a long time and have finally managed to execute.',
    url: 'https://www.shahkabir.ca',
    year: 2025,
    image: portfolioImage,
    tech: ['React', 'Sass', 'React Router', 'Vercel'],
  },
  {
    title: 'Promotional Web App',
    description:
      'A modern promotional web app built with Next.js that allows users to subscribe to a mailing list, view blog posts, and contact the app development team. Deployed on Vercel.',
    url: 'https://mailing-list-eight.vercel.app/',
    year: 2025,
    image: youtritionImage,
    tech: ['Next.js', 'Tailwind CSS', 'Vercel'],
  },
  {
    title: 'Sterling',
    description:
      'A full‑stack loyalty program management platform built with React/Vite, Node/Express, and PostgreSQL/Prisma. It handles points earning/redemption, transfers, promotions, events, and raffles with role‑based access (regular, cashier, manager, superuser) and real‑time dashboards. Deployed on Vercel/Render, it includes cashier tooling, fraud flagging, and manager workflows for transactions and rewards. The backend may require a few moments to initialize upon visiting.',
    url: 'https://sterling-rouge.vercel.app/',
    year: 2025,
    image: sterlingImage,
    tech: ['React (Vite)', 'Express.js', 'Prisma ORM', 'PostgreSQL (Supabase)', 'JWT', 'Axios', 'Material-UI', 'Vercel', 'Render'],
  },
  {
    title: 'Rock, Paper, Scissors - Hand Gesture Recognition Game',
    description:
      'A fun real-time Rock, Paper, Scissors game using your webcam; built with Python, OpenCV, and MediaPipe.',
    url: 'https://github.com/shahkabir1/hand_rps_tracker',
    year: 2025,
    tech: ['Python', 'OpenCV', 'MediaPipe'],
  },
  {
    title: 'DRSBot',
    description:
      'A real-time, customizable Formula 1 Discord bot built with Python. It delivers current driver standings, next race details, personalized driver tracking, and automated race reminders.',
    url: 'https://github.com/shahkabir1/DRSBot',
    year: 2024,
    tech: ['Python', 'Discord API', 'AsyncIO', 'Jolpica F1 API', 'Railway'],
  },
  {
    title: 'Dynamic Weather Forecasting App',
    description:
      'A modern weather app built with Vite, JavaScript, HTML, and CSS. This app fetches real-time weather data and displays both current and hourly forecasts.',
    url: 'http://shah-weather-app.vercel.app/',
    year: 2024,
    image: weatherImage,
    tech: ['Vite', 'HTML', 'CSS', 'Vercel'],
  },
];
